module.exports = __webpack_public_path__ + "static/media/bpco.09a65897.png";